import script from "./WhatsappBusinessAccountsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./WhatsappBusinessAccountsView.vue?vue&type=script&setup=true&lang=ts"

import "./WhatsappBusinessAccountsView.vue?vue&type=style&index=0&id=b5d82254&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b5d82254"]])

export default __exports__